module.exports = __webpack_public_path__ + "assets/img/IMG001.8dca9e5a.png";